import { fg } from '@atlaskit/platform-feature-flags';

import { initialPreferencesAreMissing } from '../../controllers/cookie-controls/transformer';
import type { PrefetchedConsentPreferences } from '../../services/consent-hub-service/types';
import { hasPrefetchedDataConsents } from '../../services/consent-hub-service/utils';
import { PrefetchedPreferenceState } from '../../types';

export const shouldShowBannerInSSRContext = (
	initialPreferences?: PrefetchedConsentPreferences,
): boolean => {
	if (fg('platform_moonjelly_bsc_ssr_killswitch')) {
		// If our bsc ssr killswitch is enabled, we should not show the banner
		// in SSR context
		return false;
	}

	if (initialPreferences === PrefetchedPreferenceState.INTERNAL) {
		// If we're in the "fetch internally" state, we have no prefetched data and we can't determine
		// if the user has consented or not yet since we need to fetch, so show the banner
		return true;
	}

	// Confluence the banner will render on the UI, so we should plan to render here too
	if (!initialPreferences || initialPreferencesAreMissing(initialPreferences)) {
		return true;
	}

	// If prefetched data has a consentToken or the consents array is there and populated
	// we want to hide the banner, as the user has has made consents already.
	const prefetchedDataHasConsents = hasPrefetchedDataConsents(initialPreferences);
	return !prefetchedDataHasConsents;
};
